module.exports = __webpack_public_path__ + "static/media/slide-onoake.13fb72c5.png";